import React, { useEffect } from 'react'
import { Skeleton } from 'antd'
import { useDispatch } from 'react-redux'
import { useBillingSelector } from 'store/billingSlice/billingReducer'
import { getBillingSubscription } from 'store/billingSlice/billingActions'
import { useAuthSelector } from 'store/authSlice/authReducer'
import { Subscribe } from './Subscribe'
import { SubscripionDetails } from './SubscripionDetails'

const Billing = () => {
  const dispatch = useDispatch()
  const { organization } = useAuthSelector()
  const {
    loading: { fetchingSubscription },
    subscription,
  } = useBillingSelector()

  useEffect(() => {
    if (organization?.id) {
      dispatch(getBillingSubscription(organization.id))
    }
  }, [dispatch, organization?.id])

  return (
    <Skeleton loading={fetchingSubscription} active paragraph={{ rows: 18 }}>
      {subscription ? <SubscripionDetails /> : <Subscribe />}
    </Skeleton>
  )
}

export { Billing }
